import { BET_RESULT } from 'utils/constants/index'
import { minus, plus, times } from 'number-precision'
import { v4 as uuid } from 'uuid'
import { countOnes, getCoinOutcomeProbability } from './math.utils'
import { calculateOdds } from 'utils/common-functions/index'

const DEMO_FLIP_COIN_GAME_SETTINGS = {
  id: '5',
  gameId: 5,
  minBet: {
    USD: 0.5,
    EUR: 0.5
  },
  maxBet: {
    USD: 20,
    EUR: 20
  },
  maxProfit: {
    USD: 1000,
    EUR: 1000
  },
  houseEdge: 1,
  minOdd: 1,
  maxOdd: 10000,
  minAutoRate: 1.01
}

export const flipCoinDemoPlaceBetHelper = ({ numberOfCoins, heads, betAmount, clientSeed, minimumChosenOutcome, demoBalance, currencyCode, gameSettings }) => {
  try {
    // numberOfCoins validation
    if (numberOfCoins < 1 || numberOfCoins > 10) {
      throw new Error('InvalidNumberOfCoins')
    }

    // minimumChosenOutcome Validation
    if (minimumChosenOutcome < 1 || minimumChosenOutcome > numberOfCoins || (minimumChosenOutcome < Math.floor(numberOfCoins / 3))) {
      throw new Error('InvalidMinimumChosenOutcomeErrorType')
    }

    const { minBet, maxBet, maxProfit } = DEMO_FLIP_COIN_GAME_SETTINGS

    if (betAmount < +minBet.amount || betAmount > +maxBet.amount) {
      throw new Error('BetAmountIsNotInLimitErrorType', `betAmount ${betAmount}`)
    }

    const serverSeed = Math.random()

    const calculateResult = (numberOfCoins) => {
      let result = ''
      for (let i = 0; i < numberOfCoins; i++) {
        result += Math.random() < 0.5 ? '0' : '1'
      }
      return result
    }

    const flipCoinGameResult = calculateResult(numberOfCoins)
    const ones = countOnes(flipCoinGameResult)
    const favorable = heads ? ones : (numberOfCoins - ones)

    let winningAmount = 0
    let betResult = BET_RESULT.LOST

    const probability = getCoinOutcomeProbability(numberOfCoins, minimumChosenOutcome)

    if (favorable >= minimumChosenOutcome) {
      const odds = calculateOdds({ ...gameSettings, odds: (1 / probability) })
      betResult = BET_RESULT.WON
      winningAmount = times(betAmount, odds)
      const profit = minus(winningAmount, betAmount)

      if (profit > maxProfit.amount) {
        winningAmount = plus(betAmount, maxProfit.amount)
      }
    }

    return {
      id: uuid(),
      betAmount,
      winningAmount,
      outcome: flipCoinGameResult,
      heads,
      numberOfCoins,
      minimumChosenOutcome,
      result: betResult,
      clientSeed,
      serverSeed
    }
  } catch (error) {
    throw new Error(error)
  }
}
